/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPng = createReactComponent("png", "IconPng", [
  [
    "path",
    { d: "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", key: "svg-0" }
  ],
  ["path", { d: "M3 16v-8h2a2 2 0 1 1 0 4h-2", key: "svg-1" }],
  ["path", { d: "M10 16v-8l4 8v-8", key: "svg-2" }]
]);

export { IconPng as default };
//# sourceMappingURL=IconPng.js.map
